import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import EnhancedModulePage from './components/EnhancedModulePage';
import QuizPage from './components/QuizPage';
import AchievementsPage from './components/AchievementsPage';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/modulos/:moduleId" element={<EnhancedModulePage />} />
        <Route path="/modulos/:moduleId/quiz" element={<QuizPage />} />
        <Route path="/conquistas" element={<AchievementsPage />} />
      </Routes>
    </Router>
  );
}
